/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ role: NonNullable<unknown>, detail: NonNullable<unknown> }} Perks_Carry_FailedInputs */



/**
* | output |
* | --- |
* | "@{role} couldn't take this perk's access: {detail}" |
*
* @param {Perks_Carry_FailedInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perks_carry_failed = /** @type {((inputs: Perks_Carry_FailedInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perks_Carry_FailedInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ (`Роли @${i?.role} не удалось передать доступ этой привилегии: ${i?.detail}`)
	return /** @type {LocalizedString} */ (`@${i?.role} couldn't take this perk's access: ${i?.detail}`)
});